// extracted by mini-css-extract-plugin
export default {"card":"assessment-type_card__4MY6x"};